var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"ripple",rawName:"v-ripple"}],class:( _obj = { invert: _vm.invert, dark: _vm.$vuetify.theme.dark }, _obj[("color-" + _vm.colorStrength)] = true, _obj ),attrs:{"type":_vm.type,"disalbed":_vm.disalbed},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }